const sanitizeCookie = (cookieName: string) =>
  cookieName?.replace?.(/^"(.*)"$/, "$1");

export default sanitizeCookie;
